// @flow
import React, { type Node, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'ramda';

import { useCurrencySign } from 'app/common/components-next/currency';
import { ContentScrollbars } from 'app/common/ui-next/plain-modal';
import type { OrderItem } from 'app/common/components/Cafeteria/dataTypes/order/OrderItem.types';
import Loading from 'app/common/components/Loader';

import ComplexItem from '../../../../commonComponents/ComplexItem';
import ExchangeColumnHeader from './ExchangeColumnHeader';

import styles from './ExchangeTargets.module.scss';;


type Props = {
  headerClassName?: string,
  contentClassName?: string,
  itemClassName?: string,
  items: Array<OrderItem>,
  currentTarget: string | null,
  loading: boolean,
  disabled?: boolean,
  children: Node,
  onClickTarget: (id: string) => void,
}

const ExchangeTargets = ({
  headerClassName,
  contentClassName,
  itemClassName,
  items,
  currentTarget,
  loading,
  disabled,
  children,
  onClickTarget,
}: Props): Node => {
  const currency = useCurrencySign();
  const { t } = useTranslation('cafeteria');

  const headerTitle = t(
    'order_request_sales_exchange_complex_target_column_title',
    'Назначенные комплекты:',
  );

  const description = t(
    'order_request_sales_exchange_complex_target_column_description',
    'Выберите комплект, который необходимо заменить',
  );

  const nothing = isEmpty(items);

  return (
    <Fragment>
      <ExchangeColumnHeader
        className={headerClassName}
        title={headerTitle}
        description={description}
      />
      <div className={contentClassName}>
        <ContentScrollbars
          className={styles.scroller}
          autoHeight={false}
          maxHeight="inherit"
        >
          {loading && <Loading />}

          {!loading && nothing && children}

          {!loading && items.map(({
            id,
            title,
            cost,
            amount,
            complex,
            isNew,
          }) => {
            if (complex) {
              const { dishes, freeCount } = complex;

              return (
                <ComplexItem
                  className={itemClassName}
                  key={id}
                  id={id}
                  title={title}
                  dishes={dishes}
                  cost={(amount - freeCount) * cost}
                  currency={currency}
                  onCheck={onClickTarget}
                  checked={currentTarget === id}
                  disabled={(!!currentTarget && currentTarget !== id) || disabled}
                  isFree={!!freeCount}
                  isNew={isNew}
                  exchangeTarget
                />
              );
            }

            return null;
          })}
        </ContentScrollbars>
      </div>

    </Fragment>
  );
};

export default ExchangeTargets;
